"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = require("../Button");

var _AppSwitcherIcon = _interopRequireDefault(require("../Icons/AppSwitcherIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "Button",
  componentId: "sc-1yjqw4r-0"
})([""]);

var MenuItem = _styledComponents.default.div.withConfig({
  displayName: "MenuItem",
  componentId: "sc-1yjqw4r-1"
})(["padding-top:8px;"]);

var DesktopAppSwitcherMenuItem = function DesktopAppSwitcherMenuItem(_ref) {
  var onClick = _ref.onClick;
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1040px)'
  });

  if (!isDesktop) {
    return null;
  }

  return _react.default.createElement(MenuItem, null, _react.default.createElement(Button, {
    buttonStyle: "secondary",
    onClick: onClick,
    icon: _AppSwitcherIcon.default
  }));
};

var _default = DesktopAppSwitcherMenuItem;
exports.default = _default;